module.exports = __webpack_public_path__ + "static/be-circle-mark-e05c662483f8aa9e0067d6c26d7183fb.png";